// extracted by mini-css-extract-plugin
export default {"List":"ChangeList_List__0k3X+","TableWrapper":"ChangeList_TableWrapper__uJaay"};